import {combineReducers} from 'redux'
import CommonReducer from './CommonReducer.jsx'
import PageReducer from './PageReducer.jsx'
import RadioReducer from './RadioReducer.js'
import BackgroundReducer from './BackgroundReducer.js'

const RootReducer = combineReducers({
  common: CommonReducer,
  page: PageReducer,
  radio: RadioReducer,
  bg: BackgroundReducer
})

export default RootReducer
